module.exports = __webpack_public_path__ + "img/insert.16e00a31.png";